export default __webpack_public_path__ + "static/media/dashboard.52ca164b.svg";